export default __webpack_public_path__ + "static/media/carrrr.2365927d.PNG";